// src/pages/Home.js
import React, { useState, useEffect, useCallback } from 'react'; // Added useCallback as fetchImages uses it
import useLocale from '../hooks/useLocale'; // For translated strings
import './home.css'; // Assuming you have CSS for this page


function Home() {
    // 1. Get 't' function instead of 'strings'
    const [imageCount, setImageCount] = useState(null);
    const [countError, setCountError] = useState(null);
    const { handleLanguageChange, t } = useLocale();
    

    // Fetch images function - no string changes needed inside here *yet*
    // unless you want to localize the console logs or error messages further.
    // The dependency array below might need 't' if setError used it.
    const fetchImageCount = useCallback(async () => {
        setCountError(null);
        try {
            const apiUrl = '/api/image-count'; // Removed leading / assuming proxy handles it, adjust if needed
            console.log(`Workspaceing image count from: ${apiUrl}`);
            const response = await fetch(apiUrl);
            if (!response.ok) {
                // Could use t() here if backend sent an error code
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            setImageCount(data.imageCount);
            console.log(`Image count received: ${data.imageCount}`);
        } catch (e) {
            console.error("Error fetching image count:", e);
            // Set error using raw message for now, or use t() with a generic key
            // setError(t('home_error_loading_image_count', 'Could not load image count.'));
            setCountError(e.message); // Sticking with raw error message for now
        }
        // isLoading state not used here, consider adding if fetch takes time
    }, []); // Removed user from dependency array as it wasn't used inside fetchImageCount

    useEffect(() => {
        fetchImageCount();
    }, [fetchImageCount]); // Correct dependency is the function itself

    return (
        <div>
            <button onClick={() => handleLanguageChange('en')}>English</button>
            <button onClick={() => handleLanguageChange('es')}>Spanish</button>
            {/* Note: Language buttons removed as they likely live in Banner/Footer */}
            {/* 2. Use t() for all strings, using new standardized keys */}
            <h1>{t('home_title', 'Home Page')}</h1>
            <p>{t('home_welcome', 'Welcome to AstronomyShare.com')}</p>

            {/* Section to display the image count */}
            <div className="image-count-display"> {/* Use class for styling */}
                {imageCount === null && !countError && (
                    <p>{t('home_loading_image_count', 'Loading image count...')}</p>
                )}
                {countError && (
                    // Use t() for error message, could map specific errors later
                    <p className="error-text">{t('home_error_loading_image_count', 'Could not load image count.')}</p>
                )}
                {imageCount !== null && typeof imageCount === 'number' && (
                    <p>
                        {t('home_image_count_prefix', 'This site is currently hosting')} {imageCount.toLocaleString()} {t('home_image_count_suffix', 'images.')}
                    </p>
                )}
            </div>

        </div>
    );
}

export default Home;